import * as React from 'react';

export const SignInError = () => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="wrapper wrapper-content">
                    <div className="errorscreen middle-box text-center animated fadeInDown">
                        <h1 className="logo-name">
                            <img src="/Images/Misc/vitalograph-logo.png" alt="Vitalograph Logo" />
                        </h1>
                        <h3 className="font-bold">Unable to sign in</h3>
                        <div className="error-desc">
                            Sign in session expired. Please sign in again
                        </div>
                        <a className="btn btn-sm btn-primary btn-block" href="/" style={{ marginTop: 25 + 'px' }}>Return to Sign In</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
